export default __webpack_public_path__ + "locales/pl/FilesSettings.json?hash=7a2d5474742d02346ad27fdb6717d393";